import React from 'react'

import { FormattedMessage } from 'react-intl'
import FormattedCurrency from 'js/components/FormattedCurrency'

type Props = {
  price: number
  originalPrice: number
  isRegularPrice: boolean
  currency: string
  duration: number
}

export default function BestPlanInfo({
  price,
  currency,
  duration,
  originalPrice,
  isRegularPrice,
}: Props) {
  return (
    <div
      className={`
        absolute z-20
        top-0 right-0 top-
        text-center lg:w-full
        transform 
        -translate-y-1/2 
        mr-20 lg:mr-0
        lg:translate-x-0
  `}
    >
      <span
        className={`
        type-14-demibold-caps whitespace-nowrap
      text-white bg-red border-2 border-red
        rounded-4 lg:rounded-8
        py-2 lg:py-8 px-8 lg:px-32 z-20
      `}
      >
        <span
          className="absolute right-0 mr-30 transform translate-y-1/2 lg:hidden"
          style={{
            width: 0,
            height: 0,
            borderTop: '10px solid transparent',
            borderBottom: '10px solid transparent',
            borderRight: '10px solid rgb(250, 105, 70)',
          }}
        ></span>
        <span className="relative z-20">
          {!isRegularPrice ? (
            <FormattedMessage
              defaultMessage="Save {amount}!"
              id="chooseSubscription.save"
              values={{
                amount: (
                  <FormattedCurrency
                    value={(originalPrice - price) * duration}
                    currency={currency}
                  />
                ),
              }}
            />
          ) : (
            <FormattedMessage
              defaultMessage="Save {amount}/mon!"
              id="chooseSubscription.savePerMonth"
              values={{
                amount: (
                  <FormattedCurrency
                    value={originalPrice - price}
                    currency={currency}
                  />
                ),
              }}
            />
          )}
        </span>
      </span>
    </div>
  )
}
